/** The layers route's body: a little-endian uint32 count, that many uint32 lengths, then the frames. */
export function splitFrames(body: ArrayBuffer): (Uint8Array | null)[] {
  const view = new DataView(body);
  const n = view.getUint32(0, true);
  let at = 4 * (n + 1);
  return Array.from({ length: n }, (_, k) => {
    const length = view.getUint32(4 * (k + 1), true);
    const frame = length ? new Uint8Array(body, at, length) : null;
    at += length;
    return frame;
  });
}
